import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/newsletter'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/dashboard/newsletter',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/newsletter'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/newsletter'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/newsletter'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/newsletter'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/newsletter'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\LegacyAdminRedirectController::__invoke
* @see app/Http/Controllers/Admin/LegacyAdminRedirectController.php:26
* @route '/dashboard/newsletter'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\NewsletterController::destroy
* @see app/Http/Controllers/NewsletterController.php:51
* @route '/dashboard/newsletter/{subscriber}'
*/
export const destroy = (args: { subscriber: string | number | { id: string | number } } | [subscriber: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/dashboard/newsletter/{subscriber}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\NewsletterController::destroy
* @see app/Http/Controllers/NewsletterController.php:51
* @route '/dashboard/newsletter/{subscriber}'
*/
destroy.url = (args: { subscriber: string | number | { id: string | number } } | [subscriber: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { subscriber: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { subscriber: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            subscriber: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        subscriber: typeof args.subscriber === 'object'
        ? args.subscriber.id
        : args.subscriber,
    }

    return destroy.definition.url
            .replace('{subscriber}', parsedArgs.subscriber.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\NewsletterController::destroy
* @see app/Http/Controllers/NewsletterController.php:51
* @route '/dashboard/newsletter/{subscriber}'
*/
destroy.delete = (args: { subscriber: string | number | { id: string | number } } | [subscriber: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\NewsletterController::destroy
* @see app/Http/Controllers/NewsletterController.php:51
* @route '/dashboard/newsletter/{subscriber}'
*/
const destroyForm = (args: { subscriber: string | number | { id: string | number } } | [subscriber: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\NewsletterController::destroy
* @see app/Http/Controllers/NewsletterController.php:51
* @route '/dashboard/newsletter/{subscriber}'
*/
destroyForm.delete = (args: { subscriber: string | number | { id: string | number } } | [subscriber: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const newsletter = {
    index: Object.assign(index, index),
    destroy: Object.assign(destroy, destroy),
}

export default newsletter